module.exports = __webpack_public_path__ + "img/user.becd7955.svg";